<script lang="ts">
  import Toasts from '#lib/components/page/Toasts.svelte';
  import { getTheme } from '#lib/utils/theme.svelte.js';

  import '../app.css';

  let { children } = $props();

  $effect(() => {
    localStorage.setItem('theme', getTheme());
    document.documentElement.dataset.theme = getTheme();
  });
</script>

<svelte:head>
  <title>Chartium Dashboard</title>
  <meta
    name="description"
    content="A general overview of configured maintainers, aggregated and calculated metrics."
  />
  <script>
    document.documentElement.dataset.theme = localStorage.getItem('theme') ?? 'chartium-dark';
  </script>
</svelte:head>

{@render children?.()}

<Toasts />
